exports = module.exports = require("../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".draftJsEmojiPlugin__image__192TI {}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/draft-js-image-plugin/lib/plugin.css
// module id = 1622
// module chunks = 0